import { Component, ReactNode, Suspense, lazy } from "react";
import { Spinner } from "react-bootstrap";
import { NavBar } from "../navbar/navbar";
import { useApi } from "../home/apiService";
import { useLanguage } from "../../i18n/LanguageProvider";
import { useUrlState } from "../../hooks/useUrlState";
import { COUNTRIES } from "../home/constants";
import "./map.css";

// MapLibre is heavy — load it only when the Karta route is opened.
const MapView = lazy(() => import("./MapView"));

// Surface render/chunk errors from the map instead of a blank area.
class MapErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  componentDidCatch(error: Error) {
    console.error("[map] render error", error);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="map-loading">
          Kartan kunde inte laddas: {this.state.error.message}
        </div>
      );
    }
    return this.props.children;
  }
}

export const MapPage = () => {
  const api = useApi();
  const { t } = useLanguage();
  const { getParam } = useUrlState();
  // ?country=NO frames the map on that country (the home page's expand button).
  const countryParam = getParam("country");
  const country = countryParam && COUNTRIES.includes(countryParam) ? countryParam : undefined;

  return (
    <>
      <NavBar />
      <div className="map-page">
        <div className="map-page__head">
          <h1 className="map-page__title">{t("map.title")}</h1>
          <p className="map-page__lead">{t("map.subtitle")}</p>
        </div>
        <MapErrorBoundary>
          <Suspense
            fallback={
              <div className="map-loading">
                <Spinner animation="border" size="sm" /> {t("map.loading")}
              </div>
            }
          >
            <MapView api={api} country={country} />
          </Suspense>
        </MapErrorBoundary>
      </div>
    </>
  );
};

export default MapPage;
